// extracted by mini-css-extract-plugin
export var textBanner = "TextBanner-module--textBanner--f78Tv";
export var content = "TextBanner-module--content--OUQl-";